import { post } from '@/utils/request'
import dayjs from 'dayjs'

/**
 * @description 运营产品销量数据统计(按产品统计)
 *
 * @param {object} data 请求参数
 * @param {string} data.day 显示日期2020-01-01,选择时间段
 * @param {string} [data.day_end] 显示日期2020-01-01.时间结束的日期
 * @param {string} [data.field_type] 排序字段:1是余额购买金额,2是余额购买笔数,3是增加购买金额,4是增加购买笔数,5是总量金额,6是总量笔数 7是购买人数,8是复购率
 * @param {string} [data.sort_type] asc是正序,desc是倒叙
 * @param {string} [data.show_type] 1是按天数去查询(日,周,月的查询都是选择这个), 2是查询历史总量
 */
export default function admin_product_data_rpt(data) {
  data = { ...data || {} }
  if (data.day) {
    data.day = dayjs(data.day).format('YYYY-MM-DD')
  }

  if (data.day_end) {
    data.day_end = dayjs(data.day_end).format('YYYY-MM-DD')
  }

  return post('admin_product_data_rpt', data)
}
